<script>
export default {
  name: 'FeeDetails',
  props: {
    quoteState: {
      type: String,
      required: true
    },
    isUnlimited: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<template>
  <i class="icon icon--info tool-tip">
    <div class="content">
      <div v-if="quoteState !== 'TX'">
        We are committed to providing you with great service and 100%
        transparent pricing:
        <ul>
          <li>
            All payments include a Credit Card processing fee of $3.00
          </li>
          <li>
            Single Payment includes a Policy Fee of $30.00 ($5.00/month)
          </li>
          <li>
            Monthly Payments include a Policy Fee of $5.00
          </li>
          <li v-if="!isUnlimited">
            Monthly Payments include a Mileage Monitoring Fee of $5.00
          </li>
        </ul>
      </div>
      <div v-else>
        We are committed to providing you with great service and 100%
        transparent pricing:
        <ul>
          <li>
            Single Payment includes a Policy Fee of $30.00 ($5.00/month)
          </li>
          <li>
            Monthly Payments include a Policy Fee of $5.00
          </li>
          <li>
            Monthly Payments include a Mileage Monitoring Fee of $5.00
          </li>
        </ul>
      </div>
      <i></i>
    </div>
  </i>
</template>

<style scoped lang="scss">
.tool-tip {
  color: #737278;
  top: 2px;
  left: 2px;
  .content {
    @media (min-width: 992px) {
      width: 420px;
    }
    @media (max-width: 991px) {
      width: 415px;
      left: 8px;
      i {
        left: 50%;
      }
    }
    @media (min-width: 992px) {
      left: 50%;
    }
    @media (max-width: 760px) {
      width: 300px;
      left: -15px;
      i {
        left: 57%;
      }
    }
  }
}
</style>
